import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFocusRemove: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconFocusRemove"><Path d="M3.75 8V6.75C3.75 5.09315 5.09315 3.75 6.75 3.75H8M3.75 16V17.25C3.75 18.9069 5.09315 20.25 6.75 20.25H8M16 3.75H17.25C18.9069 3.75 20.25 5.09315 20.25 6.75V8M20.25 16V17.25C20.25 18.9069 18.9069 20.25 17.25 20.25H16M9.7019 9.7019L12 12M12 12L14.2981 14.2981M12 12L9.7019 14.2981M12 12L14.2981 9.7019" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconFocusRemove;
